import { createPortal } from "react-dom";
import ParticipantQuotes from "./ParticipantQuotes";
import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CONTACT_PHONE_NOTE,
  shouldShowContactPhoneFields,
} from "./ContactPhoneFields";
import formEmailMetadata from "../data/form-email-metadata.json";
import layoutHeights from "../data/layout-heights.json";
import socialFeed from "../data/social-feed.json";
import formMarkup from "../data/squarespace-form-markup.json";
import { customFormMarkup } from "../data/customFormMarkup";
import initializeFluidImages from "../utils/initializeFluidImages";
import loadMirrorStylesheet from "../utils/loadMirrorStylesheet";
import "./SquarespaceMirror.css";

const formspreeEndpoint = "https://formspree.io/f/mrgnqryj";
const mobileClassicImageAspectOverrides = new Map([
  ["block-2489e83ab299e3cde846", 1000 / 581],
  ["block-yui_3_17_2_1_1723676951043_5123", 1000 / 563],
]);

const mirrorRuntimeCss = `
.pricing-context {
  margin: 16px 0 0;
  font-size: 1rem;
  line-height: 1.5;
}
.pricing-context a {
  color: inherit;
  text-decoration: underline;
  text-underline-offset: 0.18em;
}
.pricing-context-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: auto !important;
  padding-bottom: 24px;
}
.pricing-context-actions > .sqs-block-button-element {
  flex: none;
  box-sizing: border-box;
  min-height: 56px;
  width: 100%;
}
.pricing-context-actions .pricing-context {
  width: 100%;
  text-align: center;
}
.pricing-context-actions .pricing-context a {
  display: inline-block;
}
/* Keep the walkthrough button aligned with the adjacent trial button. */
.fe-block-yui_3_17_2_1_1776995877633_6246 .sqs-block {
  justify-content: flex-start;
}
.fe-block-yui_3_17_2_1_1776995877633_6246 .sqs-block-button-container {
  height: 56px !important;
}
#inputForm {
  width: 290px;
  max-width: 100%;
  margin-left: 0;
}
#inputForm .input-field {
  box-sizing: border-box;
  flex: 1 1 0;
  min-width: 0;
}
#inputForm .submit-button {
  flex-shrink: 0;
}
.sqs-block-form .form-item.email > .option label {
  display: inline-flex;
  align-items: center;
  column-gap: 11px;
}
.sqs-block-form .form-item.email > .option input {
  display: flex;
}
.sqs-block-form .form-item.email > .option label > span {
  display: block;
}
.sqs-block-form .form-item.email > .option {
  box-sizing: content-box;
  min-height: 0;
  height: 26px;
  word-break: break-word;
}
@media (min-width: 768px) {
  .fe-block-e6e9f76d13f3c2af9a95 {
    grid-column: 2 / -2;
    justify-self: end;
    width: 290px;
    max-width: 100%;
  }
  #block-856b5638a2925bf3d82c .sqs-block-alignment-wrapper {
    align-items: flex-start !important;
    box-sizing: border-box;
    padding-top: clamp(70px, 5.5vw, 160px);
  }
}
.sqs-block-form fieldset.name > legend .title {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.sqs-block-form .mirror-contact-phone__note {
  display: block;
  margin: 8px 0 0;
  max-width: 68ch;
  font-size: 0.9em;
  line-height: 1.45;
  opacity: 0.78;
}
.sqs-block-form .mirror-contact-phone__note a {
  color: inherit;
  text-decoration: underline;
  text-underline-offset: 0.18em;
}
.sqs-block-form .mirror-contact-phone__number {
  display: grid !important;
  width: 100% !important;
  min-width: 0;
  margin: 0 0 20px !important;
  padding: 0 !important;
  border: 0 !important;
  outline: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  box-sizing: border-box;
  position: relative;
}
.sqs-block-form .mirror-contact-phone__number::before,
.sqs-block-form .mirror-contact-phone__number::after {
  display: none !important;
  content: none !important;
}
.sqs-block-form .mirror-contact-phone__number > .title {
  display: block !important;
  width: 100% !important;
}
.sqs-block-form .mirror-contact-phone__number input[type="tel"] {
  display: block !important;
  width: 100% !important;
  height: 52px !important;
  min-height: 0 !important;
  margin-top: 12px !important;
  padding: 4px 0 10px !important;
  border: 0 !important;
  border-bottom: 1px solid currentColor !important;
  background: transparent !important;
  box-shadow: none !important;
  color: inherit !important;
}
.sqs-block-form .mirror-contact-phone__number .form-input-effects {
  display: none !important;
}
.sqs-block-form .mirror-contact-phone__preferences {
  display: flex !important;
  margin: 12px 0 0 !important;
  padding: 0 !important;
  border: 0 !important;
  min-height: 0 !important;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 18px;
  background: transparent !important;
}
.sqs-block-form .mirror-contact-phone__preference-prompt {
  display: inline !important;
  color: inherit !important;
  font-size: 0.92em;
  line-height: 1.2;
}
.sqs-block-form .mirror-contact-phone__preferences .option {
  display: inline-flex !important;
  width: auto !important;
  height: auto !important;
  min-height: 0 !important;
  align-items: center;
  margin: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  background: transparent !important;
}
.sqs-block-form .mirror-contact-phone__preferences label {
  display: inline-flex !important;
  align-items: center;
  column-gap: 8px;
  min-height: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  background: transparent !important;
  color: inherit !important;
  box-shadow: none !important;
}
.sqs-block-form .mirror-contact-phone__preferences input[type="checkbox"] {
  appearance: auto !important;
  -webkit-appearance: checkbox !important;
  position: static !important;
  display: inline-block !important;
  width: 16px !important;
  min-width: 16px;
  height: 16px !important;
  margin: 0 !important;
  padding: 0 !important;
  border: initial !important;
  opacity: 1 !important;
  box-shadow: none !important;
  accent-color: currentColor;
}
.sqs-block-form .mirror-contact-phone__preferences label > span {
  display: inline !important;
  padding: 0 !important;
  border: 0 !important;
  background: transparent !important;
  color: inherit !important;
  box-shadow: none !important;
}
.sqs-block-form .mirror-contact-phone__preferences label > span::before,
.sqs-block-form .mirror-contact-phone__preferences label > span::after {
  display: none !important;
  content: none !important;
}
.mirror-social-feed {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
}
.mirror-social-feed__card {
  position: relative;
  display: block;
  overflow: hidden;
  aspect-ratio: 4 / 5;
  border-radius: 6px;
  background: #171717;
}
.mirror-social-feed__card img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 180ms ease, transform 180ms ease;
}
.mirror-social-feed__card:hover img,
.mirror-social-feed__card:focus-visible img {
  opacity: 0.78;
  transform: scale(1.025);
}
.mirror-social-feed__type {
  position: absolute;
  top: 12px;
  right: 12px;
  display: inline-flex;
  min-width: 42px;
  min-height: 26px;
  align-items: center;
  justify-content: center;
  padding: 4px 9px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.72);
  color: #fff;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.04em;
  line-height: 1;
  text-transform: uppercase;
}
.mirror-bokeh-background {
  position: absolute;
  inset: 0;
  overflow: hidden;
}
.mirror-bokeh-particle {
  position: absolute;
  display: block;
  border-radius: 50%;
  pointer-events: none;
  animation: mirror-bokeh-float var(--mirror-bokeh-duration) ease-in-out
    var(--mirror-bokeh-delay) infinite alternate;
  will-change: transform;
}
@keyframes mirror-bokeh-float {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    transform: translate3d(var(--mirror-bokeh-x), var(--mirror-bokeh-y), 0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .mirror-bokeh-particle {
    animation: none;
  }
}
@media (max-width: 767px) {
  .mirror-social-feed {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
  .mirror-social-feed__type {
    top: 8px;
    right: 8px;
  }
  .sqs-block-form .form-item.select select {
    display: block;
    width: 100%;
    margin: 0;
  }
  .sqs-block-form .form-item.select > div {
    display: flex;
    height: 37.796875px;
  }
  .sqs-block-form .form-item.select > div > select {
    height: 100%;
  }
  .sqs-block-form .form-item.file .file-upload {
    height: 112px;
  }
  .sqs-block-form .form-item.file [data-testid="file-drop-zone"],
  .sqs-block-form .form-item.file [data-testid="file-drop-zone"] > label {
    display: block;
    height: 110px;
  }
  .sqs-block-form .form-item.file input[type="file"] {
    display: block;
    width: 100%;
  }
  .sqs-block-form .form-item.email > .option {
    display: flex;
    height: calc(1.8em + 0.398px);
    align-items: flex-end;
  }
}`;

const initialHeightFor = (route) => {
  const measured = layoutHeights[route];
  if (!measured) return 900;
  const useMobile =
    typeof window !== "undefined" &&
    window.matchMedia?.("(max-width: 767px)").matches;
  const heights = useMobile ? measured.mobile : measured.desktop;
  return Math.max(
    1,
    Math.ceil((heights || []).reduce((total, height) => total + height, 0)),
  );
};

const copyAttributes = (source, target) => {
  for (const attribute of source.attributes) {
    target.setAttribute(attribute.name, attribute.value);
  }
};

const activateShadowCss = (css = "") =>
  css.replace(/:root\b/g, ":host");

const configureBackgroundVideos = (root) => {
  root
    .querySelectorAll(".sqs-video-background-native")
    .forEach((background) => {
      const video = background.querySelector("video");
      if (video) {
        video.defaultMuted = true;
        video.muted = true;
        video.loop = true;
      }

      if (background.dataset.configFilter !== "6") return;
      const strength = Number.parseFloat(
        background.dataset.configFilterStrength,
      );
      if (!Number.isFinite(strength)) return;
      const opacity = Math.min(100, Math.max(0, strength)) / 100;
      background.style.filter = `opacity(${opacity})`;
    });
};

const paletteVariableFor = (color) => {
  const id = color?.sitePaletteColor?.id;
  if (!id) return "--white-hsl";
  return `--${id}-hsl`;
};

const seededRandom = (seed) => {
  let state = Math.trunc(seed) || 1;
  return () => {
    state = (state * 1664525 + 1013904223) >>> 0;
    return state / 4294967296;
  };
};

export const hydrateGenerativeBackgrounds = (root) => {
  root
    .querySelectorAll('[data-controller="BackgroundBokeh"]')
    .forEach((background) => {
      const section = background.closest("section[data-current-styles]");
      const canvas = background.querySelector(".background-fx-canvas");
      if (!section || !canvas) return;

      let sectionStyles;
      try {
        sectionStyles = JSON.parse(section.dataset.currentStyles || "{}");
      } catch {
        return;
      }

      const settings = sectionStyles.generative;
      if (
        sectionStyles.backgroundMode !== "generative" ||
        settings?.type !== "bokeh"
      ) {
        return;
      }

      const random = seededRandom(settings.seed);
      const particleCount = Math.max(
        36,
        Math.min(72, 30 + (Number(settings.count) || 1) * 9),
      );
      const backgroundVariable = paletteVariableFor(
        settings.backgroundColor,
      );
      const particleVariables = [
        paletteVariableFor(settings.color1),
        paletteVariableFor(settings.color2),
        paletteVariableFor(settings.color3),
      ];
      const fragment = document.createDocumentFragment();

      for (let index = 0; index < particleCount; index += 1) {
        const particle = document.createElement("span");
        const diameter = Math.round(3 + Math.pow(random(), 2.15) * 52);
        const alpha = (0.08 + random() * 0.27).toFixed(3);
        const color = particleVariables[index % particleVariables.length];
        particle.className = "mirror-bokeh-particle";
        particle.setAttribute("aria-hidden", "true");
        particle.style.width = `${diameter}px`;
        particle.style.height = `${diameter}px`;
        particle.style.left = `${(random() * 100).toFixed(2)}%`;
        particle.style.top = `${(random() * 100).toFixed(2)}%`;
        particle.style.backgroundColor = `hsla(var(${color}), ${alpha})`;
        particle.style.filter = `blur(${Math.max(0.5, diameter * 0.12).toFixed(1)}px)`;
        particle.style.setProperty(
          "--mirror-bokeh-x",
          `${Math.round(random() * 18 - 9)}px`,
        );
        particle.style.setProperty(
          "--mirror-bokeh-y",
          `${Math.round(random() * 22 - 11)}px`,
        );
        particle.style.setProperty(
          "--mirror-bokeh-duration",
          `${Math.round(18 + random() * 20)}s`,
        );
        particle.style.setProperty(
          "--mirror-bokeh-delay",
          `${Math.round(random() * -20)}s`,
        );
        fragment.appendChild(particle);
      }

      canvas.classList.add("mirror-bokeh-background");
      canvas.style.backgroundColor = `hsla(var(${backgroundVariable}), 1)`;
      canvas.replaceChildren(fragment);
    });
};

const upsertHiddenFormField = (form, name, value) => {
  let field = form.querySelector(`input[type="hidden"][name="${name}"]`);
  if (!field) {
    field = document.createElement("input");
    field.type = "hidden";
    field.name = name;
    form.prepend(field);
  }
  field.value = value;
};

export const applyFormEmailMetadata = (form, route) => {
  const metadata = formEmailMetadata[route];
  if (!metadata) return;
  upsertHiddenFormField(form, "subject", metadata.subject);
  upsertHiddenFormField(form, "form_name", metadata.formName);
};

const createFormTitle = (document, tagName, text, options = {}) => {
  const title = document.createElement(tagName);
  title.className =
    tagName === "label" ? "title YB_rseKyzcQ64VtF" : "";
  if (tagName === "label" && options.forId) {
    title.setAttribute("for", options.forId);
  }
  if (options.id) title.id = options.id;

  const outer = document.createElement("div");
  outer.className =
    tagName === "label" ? "KBeHkQJXlg4N1Ujt" : "title";
  const inner = document.createElement("div");
  inner.className =
    tagName === "label" ? "SP08ZLkhAnk2Rqaf" : "s9aw5DV2uY72CSBH";
  const label = document.createElement("span");
  label.textContent = text;
  inner.appendChild(label);

  if (options.optional) {
    const optional = document.createElement("span");
    optional.className = "description";
    optional.textContent = "(optional)";
    inner.appendChild(optional);
  }

  outer.appendChild(inner);
  title.appendChild(outer);
  return title;
};

const appendFormInputEffects = (document, item) => {
  const effects = document.createElement("span");
  effects.className = "V60Xg8ZMr2Q9qLks form-input-effects";
  effects.setAttribute("aria-hidden", "true");
  const border = document.createElement("span");
  border.className = "form-input-effects-border";
  effects.appendChild(border);
  item.appendChild(effects);
};

const createPhoneNote = (document) => {
  const note = document.createElement("p");
  note.className = "description mirror-contact-phone__note";
  note.textContent = CONTACT_PHONE_NOTE;
  return note;
};

const createContactPhoneNumberField = (document, form) => {
  const field = document.createElement("div");
  const fieldId = `${form.id || "mirror"}-phone-field`;
  field.className = "mirror-contact-phone__number";
  field.setAttribute("data-contact-phone-fields", "");
  field.appendChild(
    createFormTitle(document, "label", "Phone number", {
      forId: fieldId,
      optional: true,
    }),
  );
  field.appendChild(createPhoneNote(document));

  const input = document.createElement("input");
  input.setAttribute("aria-invalid", "false");
  input.setAttribute("aria-required", "false");
  input.autocomplete = "tel";
  input.className = "ngonnDl0lqs7ZArA";
  input.id = fieldId;
  input.name = "phone";
  input.type = "tel";
  field.appendChild(input);
  appendFormInputEffects(document, field);
  field.appendChild(createContactPreferenceFields(document));
  return field;
};

const createContactPreferenceFields = (document) => {
  const field = document.createElement("div");
  field.className = "mirror-contact-phone__preferences";
  field.setAttribute("aria-label", "Phone follow-up options");
  field.setAttribute("role", "group");
  const prompt = document.createElement("span");
  prompt.className = "mirror-contact-phone__preference-prompt";
  prompt.textContent = "You can";
  field.appendChild(prompt);

  ["Call", "Text"].forEach((preference) => {
    const option = document.createElement("div");
    option.className = "option";
    const label = document.createElement("label");
    label.className = "NyhiP5suSp03OhA1";
    const input = document.createElement("input");
    input.className = "wIoTXuBC0lMFtpfY";
    input.name = "phone_contact_preference";
    input.type = "checkbox";
    input.setAttribute("value", preference);
    const text = document.createElement("span");
    text.setAttribute("data-dynamic-strings", "true");
    text.textContent = `${preference.toLowerCase()} me`;
    label.append(input, text);
    option.appendChild(label);
    field.appendChild(option);
  });

  return field;
};

export const hydrateContactPhoneFields = (form, route) => {
  if (!shouldShowContactPhoneFields(route)) return;
  if (form.querySelector("[data-contact-phone-fields]")) return;

  const document = form.ownerDocument;
  const fieldList = form.querySelector(".field-list") || form;
  const phoneField = createContactPhoneNumberField(document, form);
  const emailField = fieldList.querySelector(".form-item.email");

  if (emailField) {
    emailField.after(phoneField);
  } else {
    fieldList.append(phoneField);
  }
};

const hydrateForms = (root, route) => {
  Object.entries({ ...formMarkup, ...customFormMarkup(formMarkup) }).forEach(
    ([blockId, form]) => {
      const wrapper = root.querySelector(
        `#${CSS.escape(blockId)} .form-wrapper`,
      );
      if (!wrapper || !form.html) return;

      const template = document.createElement("template");
      template.innerHTML = form.html;
      const hydratedWrapper = template.content.firstElementChild;
      if (!hydratedWrapper) return;
      wrapper.replaceWith(hydratedWrapper);

      const element = hydratedWrapper.querySelector("form");
      if (!element) return;
      element.action = formspreeEndpoint;
      element.method = "POST";
      element.setAttribute("data-formspree-mirror", "");
      applyFormEmailMetadata(element, route);
      hydrateContactPhoneFields(element, route);

      element.querySelectorAll("input, select, textarea").forEach((field) => {
        if (field.name) return;
        const label = field.id
          ? element.querySelector(`label[for="${CSS.escape(field.id)}"]`)
          : null;
        const groupLabel = field.closest("fieldset")?.querySelector("legend");
        const name = (label || groupLabel)?.textContent
          ?.replace(/\(required\)/gi, "")
          .replace(/\s+/g, " ")
          .trim();
        field.name = name || field.id || "field";
      });
    },
  );
};

const socialIconPaths = {
  instagram:
    "M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5Zm0 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7Zm5 3a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm5.5-3.25a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z",
  bluesky:
    "M12 10.8c-1.09-2.12-4.05-6.07-6.8-8.02C2.57.91 1.57 1.23.92 1.53.17 1.88 0 3.07 0 3.77c0 .71.39 5.82.64 6.67.84 2.83 3.83 3.79 6.58 3.48-4.78.71-9.03 2.43-3.46 8.62 6.13 6.35 8.4-1.36 8.24-5.49-.16 4.13 2.11 11.84 8.24 5.49 5.57-6.19 1.32-7.91-3.46-8.62 2.75.31 5.74-.65 6.58-3.48.25-.85.64-5.96.64-6.67 0-.7-.17-1.89-.92-2.24-.65-.3-1.65-.62-4.28 1.25-2.75 1.95-5.71 5.9-6.8 8.02Z",
  linkedin:
    "M5.2 7.6H1V21h4.2V7.6ZM3.1 1A2.45 2.45 0 1 0 3.1 5.9 2.45 2.45 0 0 0 3.1 1ZM21 13.3c0-4-2.1-5.9-4.9-5.9-2.3 0-3.3 1.3-3.9 2.2v-2H8V21h4.2v-7.5c0-2 .4-3.9 2.8-3.9s2.4 2.2 2.4 4V21H21v-7.7Z"
};

const svgElement = (tagName) =>
  document.createElementNS("http://www.w3.org/2000/svg", tagName);

export const hydrateSocialIcons = (root) => {
  root
    .querySelectorAll(".social-account-links-v2-block a[aria-label]")
    .forEach((anchor) => {
      const network = anchor.getAttribute("aria-label")?.toLowerCase();
      const iconPath = socialIconPaths[network];
      const svg = anchor.querySelector("svg");
      if (!iconPath || !svg) return;

      const background = svgElement("circle");
      background.setAttribute("cx", "12");
      background.setAttribute("cy", "12");
      background.setAttribute("r", "12");
      background.setAttribute("fill", "#fff");
      const glyph = svgElement("path");
      glyph.setAttribute("d", iconPath);
      glyph.setAttribute("fill", "#000");
      glyph.setAttribute("transform", "translate(4 4) scale(.666667)");
      svg.setAttribute("viewBox", "0 0 24 24");
      svg.replaceChildren(background, glyph);
    });
};

export const hydrateSocialFeed = (root) => {
  const content = root.querySelector(".instagram-block .sqs-block-content");
  const feed = socialFeed.instagram;
  if (!content || !feed?.posts?.length) return;

  const grid = document.createElement("div");
  grid.className = "mirror-social-feed";
  grid.setAttribute("aria-label", "Latest posts from 10k Science on Instagram");
  grid.setAttribute("role", "region");
  grid.dataset.snapshotDate = feed.snapshotDate;

  feed.posts.forEach((post) => {
    const link = document.createElement("a");
    link.className = "mirror-social-feed__card";
    link.href = post.url;
    link.target = "_blank";
    link.rel = "noreferrer";
    link.setAttribute("aria-label", `${post.alt} Open on Instagram.`);

    const image = document.createElement("img");
    image.alt = post.alt;
    image.decoding = "async";
    // These four local previews total less than 170 KB, so eager loading avoids
    // an empty gallery when someone scrolls quickly to the social section.
    image.loading = "eager";
    image.src = post.image;
    image.width = 512;
    image.height = 640;
    link.appendChild(image);

    if (post.type === "reel") {
      const type = document.createElement("span");
      type.className = "mirror-social-feed__type";
      type.setAttribute("aria-hidden", "true");
      type.textContent = "Reel";
      link.appendChild(type);
    }

    grid.appendChild(link);
  });

  content.replaceChildren(grid);
};

export const initializeBannerSlideshows = (root) => {
  const cleanup = [];
  const resizeTasks = [];

  root
    .querySelectorAll(".user-items-list-banner-slideshow")
    .forEach((container) => {
      const slides = [...container.querySelectorAll(".list-item")];
      const previous = container.querySelector(
        ".user-items-list-banner-slideshow__arrow-button--left",
      );
      const next = container.querySelector(
        ".user-items-list-banner-slideshow__arrow-button--right",
      );
      const mobilePrevious = container.querySelector(
        ".mobile-arrow-button--left",
      );
      const mobileNext = container.querySelector(
        ".mobile-arrow-button--right",
      );
      const slideList = container.querySelector(".slides");
      if (!slides.length) return;

      slideList?.classList.add("slides--initialized");
      [previous, next, mobilePrevious, mobileNext].forEach((button) => {
        if (button && !button.hasAttribute("type")) button.type = "button";
      });

      let activeIndex = 0;
      const positionSlides = () => {
        const space =
          window.innerWidth < 768
            ? 0
            : Number(container.dataset.spaceBetweenSlidesValue) || 0;
        const step = Math.round(
          slides[0].getBoundingClientRect().width + space,
        );
        slides.forEach((slide, slideIndex) => {
          let offset = slideIndex - activeIndex;
          if (offset > slides.length / 2) offset -= slides.length;
          if (offset < -slides.length / 2) offset += slides.length;
          const x = Math.abs(offset) > 1 ? -9999 : offset * step;
          slide.style.transform = `translate3d(${x}px, 0px, 0px)`;
          slide.setAttribute(
            "aria-hidden",
            String(slideIndex !== activeIndex),
          );
        });
      };
      const show = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        positionSlides();
      };
      const showPrevious = () => show(activeIndex - 1);
      const showNext = () => show(activeIndex + 1);

      [previous, mobilePrevious].forEach((button) =>
        button?.addEventListener("click", showPrevious),
      );
      [next, mobileNext].forEach((button) =>
        button?.addEventListener("click", showNext),
      );
      window.addEventListener("resize", positionSlides);
      resizeTasks.push(positionSlides);
      cleanup.push(() => {
        [previous, mobilePrevious].forEach((button) =>
          button?.removeEventListener("click", showPrevious),
        );
        [next, mobileNext].forEach((button) =>
          button?.removeEventListener("click", showNext),
        );
        window.removeEventListener("resize", positionSlides);
      });
    });

  return {
    destroy: () => cleanup.forEach((task) => task()),
    resize: () => resizeTasks.forEach((task) => task()),
  };
};

const initializeItemCarousels = (root) => {
  const cleanup = [];
  const resizeTasks = [];

  root.querySelectorAll(".user-items-list-carousel").forEach((container) => {
    const slides = [...container.querySelectorAll(".list-item")];
    const slideList = container.querySelector(".user-items-list-carousel__slides");
    const previous = container.querySelector(
      ".user-items-list-carousel__arrow-button--left",
    );
    const next = container.querySelector(
      ".user-items-list-carousel__arrow-button--right",
    );
    const mobilePrevious = container.querySelector(
      ".mobile-arrow-button--left",
    );
    const mobileNext = container.querySelector(
      ".mobile-arrow-button--right",
    );
    if (!slides.length) return;

    let activeIndex = 0;
    const positionSlides = () => {
      const space =
        window.innerWidth < 768
          ? 20
          : Number(container.dataset.spaceBetweenSlidesValue) || 0;
      const step = Math.round(
        slides[0].getBoundingClientRect().width + space,
      );
      const maxColumns = Math.max(
        1,
        Number(container.dataset.maxColumns) || 1,
      );
      const visibleAhead =
        window.innerWidth < 768 ? 1 : maxColumns;

      slides.forEach((slide, slideIndex) => {
        const offset =
          (slideIndex - activeIndex + slides.length) % slides.length;
        const visible = offset >= 0 && offset <= visibleAhead;
        const x = visible ? offset * step : -9999;
        slide.style.transform = `translate3d(${x}px, 0px, 0px)`;
        slide.setAttribute(
          "aria-hidden",
          String(slideIndex !== activeIndex),
        );
      });
      slideList?.classList.add("user-items-list-carousel__slides--initialized");
    };
    const show = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      positionSlides();
    };
    const showPrevious = () => show(activeIndex - 1);
    const showNext = () => show(activeIndex + 1);

    [previous, mobilePrevious].forEach((button) =>
      button?.addEventListener("click", showPrevious),
    );
    [next, mobileNext].forEach((button) =>
      button?.addEventListener("click", showNext),
    );
    window.addEventListener("resize", positionSlides);
    resizeTasks.push(positionSlides);
    cleanup.push(() => {
      [previous, mobilePrevious].forEach((button) =>
        button?.removeEventListener("click", showPrevious),
      );
      [next, mobileNext].forEach((button) =>
        button?.removeEventListener("click", showNext),
      );
      window.removeEventListener("resize", positionSlides);
    });
  });

  return {
    destroy: () => cleanup.forEach((task) => task()),
    resize: () => resizeTasks.forEach((task) => task()),
  };
};

export const initializeScaledText = (root) => {
  const resizeTasks = [];
  const cleanupTasks = [];

  root
    .querySelectorAll(".sqsrte-scaled-text-container")
    .forEach((container) => {
      const text = container.querySelector(".sqsrte-scaled-text");
      if (!text) return;

      const update = () => {
        container.classList.remove("loaded");
        const availableWidth = Math.round(container.offsetWidth);
        const naturalWidth = Math.round(text.offsetWidth);
        const baseSize = Number.parseFloat(
          getComputedStyle(text).fontSize,
        );
        if (!baseSize || !naturalWidth || !availableWidth) return;
        const fittedSize =
          Math.round(
            (baseSize * availableWidth * 10) / naturalWidth,
          ) / 10;
        text.style.fontSize = `${Math.max(1, fittedSize)}px`;
        container.classList.add("loaded");
      };

      let timeout;
      const resize = () => {
        const leading = timeout === undefined;
        window.clearTimeout(timeout);
        if (leading) update();
        timeout = window.setTimeout(() => {
          timeout = undefined;
          update();
        }, 40);
      };
      let observerFrame;
      const resizeAfterObserverDelivery = () => {
        if (observerFrame !== undefined) return;
        observerFrame = window.requestAnimationFrame(() => {
          observerFrame = undefined;
          resize();
        });
      };
      const observer =
        "ResizeObserver" in window
          ? new ResizeObserver(resizeAfterObserverDelivery)
          : null;
      observer?.observe(container);
      observer?.observe(text);
      resizeTasks.push(resize);
      window.addEventListener("resize", resize);
      cleanupTasks.push(() => {
        observer?.disconnect();
        window.cancelAnimationFrame(observerFrame);
        window.clearTimeout(timeout);
      });
    });

  return {
    destroy: () => {
      resizeTasks.forEach((task) =>
        window.removeEventListener("resize", task),
      );
      cleanupTasks.forEach((task) => task());
    },
    resize: () => resizeTasks.forEach((task) => task()),
  };
};

const initializeLegacySpacers = (root) => {
  root.querySelectorAll(".spacer-block[data-aspect-ratio]").forEach((block) => {
    const content = block.querySelector(".sqs-block-content");
    if (!content) return;
    content.classList.add("sqs-intrinsic");
    content.style.paddingBottom = `${block.dataset.aspectRatio}%`;
  });
};

const initializeLegacyImageCards = (root) => {
  const blocks = [
    ...root.querySelectorAll(".image-block:has(.image-card-wrapper)"),
  ];
  const resize = () => {
    const isNarrow = window.matchMedia("(max-width: 767px)").matches;
    blocks.forEach((block) => {
      const outer = block.querySelector(".image-block-outer-wrapper");
      const intrinsic = block.querySelector(".intrinsic");
      const shape = block.querySelector(
        ".sqs-image-shape-container-element",
      );
      const image = block.querySelector("img[data-image-dimensions]");
      block.classList.add("sqs-text-ready");
      outer?.classList.add("sqs-text-ready");
      outer?.classList.toggle("sqs-narrow-width", isNarrow);

      block
        .querySelectorAll(".image-title, .image-subtitle")
        .forEach((text) => {
          text.style.fontSize = `max(0.75rem, ${
            isNarrow ? "63.3%" : "20.7%"
          })`;
        });

      const dimensions = image
        ?.getAttribute("data-image-dimensions")
        ?.split("x")
        .map(Number);
      if (
        !isNarrow ||
        !intrinsic ||
        !shape ||
        !dimensions ||
        dimensions.length !== 2 ||
        !dimensions.every(Number.isFinite) ||
        !dimensions[0]
      ) {
        intrinsic?.style.removeProperty("height");
        shape?.style.removeProperty("height");
        return;
      }
      const aspectRatio =
        mobileClassicImageAspectOverrides.get(block.id) ||
        dimensions[0] / dimensions[1];
      const imageHeight =
        intrinsic.getBoundingClientRect().width / aspectRatio;
      intrinsic.style.height = `${imageHeight}px`;
      shape.style.height = `${imageHeight}px`;
    });
  };

  resize();
  window.addEventListener("resize", resize);
  return {
    destroy: () => window.removeEventListener("resize", resize),
    resize,
  };
};

const dividerMeasurement = (measurement, axisSize) => {
  const value = Number(measurement?.value);
  if (!Number.isFinite(value)) return 0;

  switch (measurement?.unit) {
    case "vw":
      return (window.innerWidth * value) / 100;
    case "vh":
      return (window.innerHeight * value) / 100;
    case "%":
      return (axisSize * value) / 100;
    case "px":
    default:
      return value;
  }
};

const dividerCssMeasurement = (measurement) => {
  const value = Number(measurement?.value);
  if (!Number.isFinite(value)) return "0px";
  return `${value}${measurement?.unit || "px"}`;
};

const roundedPathNumber = (value) =>
  Number(Math.max(-1000, Math.min(1000, value)).toFixed(3));

export const buildJaggedDividerPaths = ({
  borderHeight,
  borderWidth,
  dividerHeight,
  dividerWidth,
  isFlipX = false,
  isFlipY = true,
  offset = 0,
  strokeStyle = "none",
  strokeThickness = 0,
}) => {
  if (!borderHeight || !borderWidth) {
    return { clip: "M0,0", stroke: "M0,0" };
  }

  const amplitude = roundedPathNumber(
    Math.min(1, Math.floor(dividerHeight) / borderHeight),
  );
  const strokeExpansion = strokeStyle === "none" ? 0 : strokeThickness;
  const period = roundedPathNumber(
    (dividerWidth + strokeExpansion) / borderWidth,
  );
  const longSlope = roundedPathNumber(period * 0.75);
  const shortSlope = roundedPathNumber(period * 0.25);
  const firstSlope = isFlipX ? shortSlope : longSlope;
  const secondSlope = isFlipX ? longSlope : shortSlope;
  const offsetRatio = roundedPathNumber(offset / borderWidth);
  const startX = roundedPathNumber(period * 2 + offsetRatio);
  const endX = roundedPathNumber(startX - period * 3);
  const baseline = roundedPathNumber(isFlipY ? 1 - amplitude : amplitude);
  const point = roundedPathNumber(isFlipY ? 1 : 0);
  const fillEdge = isFlipY ? -1 : 2;
  const direction = isFlipY ? 1 : -1;
  const segments = Array.from(
    { length: 3 },
    () =>
      `l-${firstSlope},${roundedPathNumber(direction * amplitude)} ` +
      `l-${secondSlope},${roundedPathNumber(-direction * amplitude)}`,
  ).join(" ");
  const line =
    `M${startX}, ${baseline} L${startX}, ${baseline} l0,0 ` + segments;

  return {
    clip: `${line} L${endX}, ${fillEdge} L${startX}, ${fillEdge} z`,
    stroke: `M-100,0.5 L-100,1.5 ${line}`,
    point,
  };
};

const initializeSectionDividers = (root) => {
  const sections = [
    ...root.querySelectorAll("main#page section[data-test='page-section']"),
  ];
  const dividers = sections.map((section) => {
    try {
      const context = JSON.parse(
        section.getAttribute("data-current-context") || "{}",
      );
      return context.divider?.enabled ? context.divider : null;
    } catch {
      return null;
    }
  });

  sections.forEach((section, index) => {
    const divider = dividers[index];
    const previousDivider = dividers[index - 1];
    section.style.setProperty(
      "--previous-section-divider-offset",
      previousDivider
        ? dividerCssMeasurement(previousDivider.height)
        : "0px",
    );

    if (!divider) return;
    section.style.setProperty(
      "--divider-height",
      dividerCssMeasurement(divider.height),
    );
    section.style.setProperty("--z-index", String(sections.length - index + 1));
  });

  const update = () => {
    sections.forEach((section, index) => {
      const divider = dividers[index];
      if (!divider || divider.type !== "jagged") return;
      const border = section.querySelector(":scope > .section-border");
      const clip = section.querySelector(".section-divider-clip");
      const stroke = section.querySelector(".section-divider-stroke");
      if (!border || !clip || !stroke) return;

      const bounds = border.getBoundingClientRect();
      if (!bounds.width || !bounds.height) return;
      const paths = buildJaggedDividerPaths({
        borderHeight: bounds.height,
        borderWidth: bounds.width,
        dividerHeight: dividerMeasurement(divider.height, bounds.height),
        dividerWidth: dividerMeasurement(divider.width, bounds.width),
        isFlipX: divider.isFlipX,
        isFlipY: divider.isFlipY,
        offset: dividerMeasurement(divider.offset, bounds.width),
        strokeStyle: divider.stroke?.style,
        strokeThickness: dividerMeasurement(
          divider.stroke?.thickness,
          bounds.width,
        ),
      });
      clip.setAttribute("d", paths.clip);
      stroke.setAttribute("d", paths.stroke);
    });
  };

  let observerFrame;
  const scheduleUpdate = () => {
    if (observerFrame !== undefined) return;
    observerFrame = window.requestAnimationFrame(() => {
      observerFrame = undefined;
      update();
    });
  };
  const observer =
    "ResizeObserver" in window ? new ResizeObserver(scheduleUpdate) : null;
  sections.forEach((section) => observer?.observe(section));
  window.addEventListener("resize", scheduleUpdate);

  return {
    destroy: () => {
      observer?.disconnect();
      window.cancelAnimationFrame(observerFrame);
      window.removeEventListener("resize", scheduleUpdate);
    },
    resize: update,
  };
};

const setAccordionItemOpen = (item, open) => {
  const button = item?.querySelector(".accordion-item__click-target");
  const dropdown = item?.querySelector(".accordion-item__dropdown");
  if (!button || !dropdown) return;
  button.setAttribute("aria-expanded", String(open));
  dropdown.classList.toggle("accordion-item__dropdown--open", open);
  item.classList.remove("accordion-item--open");
};

export const toggleSquarespaceAccordion = (button) => {
  const item = button?.closest(".accordion-item");
  const container = item?.closest(".accordion-items-container");
  if (!item || !container) return false;
  const shouldOpen = button.getAttribute("aria-expanded") !== "true";

  if (
    shouldOpen &&
    container.dataset.shouldAllowMultipleOpenItems !== "true"
  ) {
    container.querySelectorAll(".accordion-item").forEach((otherItem) => {
      if (otherItem !== item) setAccordionItemOpen(otherItem, false);
    });
  }

  setAccordionItemOpen(item, shouldOpen);
  return shouldOpen;
};

const initializeClassicGalleries = (root) => {
  const cleanup = [];

  root.querySelectorAll(".sqs-gallery-block-grid").forEach((gallery) => {
    gallery
      .querySelector(".sqs-gallery")
      ?.classList.add("sqs-gallery-design-grid");
    gallery.querySelectorAll(".slide").forEach((slide) => {
      slide.classList.add("sqs-gallery-design-grid-slide");
    });
  });

  root
    .querySelectorAll(".sqs-gallery-block-slideshow")
    .forEach((container) => {
      const gallery = container.querySelector(".sqs-gallery");
      const slides = [...container.querySelectorAll(".sqs-gallery > .slide")];
      const thumbnails = container.parentElement?.querySelector(
        ".sqs-gallery-thumbnails",
      );
      const thumbnailImages = thumbnails
        ? [...thumbnails.querySelectorAll("img")]
        : [];
      if (!gallery || !slides.length) return;

      let settings = {};
      try {
        settings = JSON.parse(
          container.closest(".gallery-block")?.getAttribute(
            "data-block-json",
          ) || "{}",
        );
      } catch {
        settings = {};
      }

      gallery.classList.add("sqs-gallery-design-stacked");
      slides.forEach((slide) =>
        slide.classList.add(
          "sqs-gallery-design-stacked-slide",
          "loaded",
        ),
      );
      if (thumbnails) {
        const thumbnailHeight =
          Number(settings["thumbnail-strip-height"]) || 79;
        thumbnails.classList.add("sqs-gallery-design-strip");
        thumbnails.style.height = `${thumbnailHeight}px`;
        thumbnails.style.marginTop = "15px";
        thumbnails.style.marginBottom = "-5px";
        thumbnails.style.paddingTop = "5px";
        thumbnails.style.paddingBottom = "5px";
      }
      thumbnailImages.forEach((thumbnail) => {
        thumbnail.classList.add("sqs-gallery-design-strip-slide");
      });

      const dimensions =
        slides[0]
          ?.querySelector("img[data-image-dimensions]")
          ?.getAttribute("data-image-dimensions")
          ?.split("x")
          .map(Number) || [];
      const aspectRatio =
        dimensions.length === 2 && dimensions.every(Number.isFinite)
          ? dimensions[0] / dimensions[1]
          : 16 / 9;

      const sizeGallery = () => {
        gallery.style.height = `${gallery.clientWidth / aspectRatio}px`;
      };

      let activeIndex = 0;
      const showSlide = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === activeIndex;
          slide.classList.toggle("sqs-active-slide", active);
          slide.style.opacity = active ? "1" : "0";
          slide.style.zIndex = active ? "889" : "888";
          slide.style.overflow = "hidden";
          slide.style.visibility = active ? "visible" : "hidden";
          slide.style.pointerEvents = active ? "auto" : "none";
          const image = slide.querySelector("img.thumb-image");
          if (image) {
            image.classList.add("loaded");
            image.style.inset = "0";
            image.style.width = "100%";
            image.style.height = "100%";
            image.style.position = "absolute";
            image.style.objectFit = "cover";
          }
        });
        thumbnailImages.forEach((thumbnail, thumbnailIndex) => {
          const active = thumbnailIndex === activeIndex;
          thumbnail.classList.toggle("sqs-active-slide", active);
          thumbnail.style.opacity = active ? "1" : "0.5";
        });
      };

      thumbnailImages.forEach((thumbnail, index) => {
        const selectSlide = () => showSlide(index);
        thumbnail.addEventListener("click", selectSlide);
        cleanup.push(() =>
          thumbnail.removeEventListener("click", selectSlide),
        );
      });

      if (settings.autoplay && slides.length > 1) {
        const interval = window.setInterval(
          () => showSlide(activeIndex + 1),
          Math.max(1, Number(settings["autoplay-duration"]) || 3) * 1000,
        );
        cleanup.push(() => window.clearInterval(interval));
      }

      sizeGallery();
      showSlide(0);
      window.addEventListener("resize", sizeGallery);
      cleanup.push(() => window.removeEventListener("resize", sizeGallery));
    });

  return {
    destroy: () => cleanup.forEach((task) => task()),
    resize: () => window.dispatchEvent(new Event("resize")),
  };
};

const initializeBlogImageLoader = (root) => {
  const cards = [
    ...root.querySelectorAll(
      ".blog-basic-grid .blog-basic-grid--container",
    ),
  ];
  if (!cards.length) return { destroy: () => {} };

  const revealVisible = () => {
    cards.forEach((card) => {
      const bounds = card.getBoundingClientRect();
      if (bounds.bottom > 0 && bounds.top < window.innerHeight) {
        card.classList.add("is-loaded");
      }
    });
  };
  const observer =
    "IntersectionObserver" in window
      ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-loaded");
              observer.unobserve(entry.target);
            }
          });
        })
      : null;

  cards.forEach((card) => observer?.observe(card));
  revealVisible();
  window.addEventListener("resize", revealVisible);
  return {
    destroy: () => {
      observer?.disconnect();
      window.removeEventListener("resize", revealVisible);
    },
  };
};

const initializeGalleryReels = (root) => {
  const cleanup = [];
  const resizeTasks = [];

  root
    .querySelectorAll(".gallery-lightbox")
    .forEach((lightbox) => lightbox.remove());

  root.querySelectorAll(".gallery-reel").forEach((reel) => {
    const items = [...reel.querySelectorAll(".gallery-reel-item")];
    const controls = [...reel.querySelectorAll(".gallery-reel-control-btn")];
    if (!items.length) return;

    let activeIndex = 0;
    const itemAspectRatio = (item) => {
      const dimensions = item
        .querySelector("img[data-image-dimensions]")
        ?.getAttribute("data-image-dimensions")
        ?.split("x")
        .map(Number);
      if (
        !dimensions ||
        dimensions.length !== 2 ||
        !dimensions.every(Number.isFinite) ||
        !dimensions[1]
      ) {
        return 16 / 9;
      }
      return dimensions[0] / dimensions[1];
    };

    const positionItems = () => {
      const itemHeight = Math.max(
        1,
        Math.round(
          reel.getBoundingClientRect().height -
            (window.innerWidth < 768 ? 169 : 176),
        ),
      );
      const itemWidths = items.map((item) =>
        Math.round(itemHeight * itemAspectRatio(item)),
      );
      const activeWidth = itemWidths[activeIndex];
      const activeX = (reel.clientWidth - activeWidth) / 2;
      const previousIndex =
        (activeIndex - 1 + items.length) % items.length;
      const nextIndex = (activeIndex + 1) % items.length;
      const positions = new Map([[activeIndex, activeX]]);
      const previousX = activeX - itemWidths[previousIndex];
      const nextX = activeX + activeWidth;
      if (previousX + itemWidths[previousIndex] > 0) {
        positions.set(previousIndex, previousX);
      }
      if (nextX < reel.clientWidth) {
        positions.set(nextIndex, nextX);
      }

      items.forEach((item, index) => {
        const active = index === activeIndex;
        const visible = positions.has(index);
        const source = item.querySelector(".gallery-reel-item-src");
        const link = item.querySelector("a");
        item.style.width = `${itemWidths[index]}px`;
        item.style.height = `${itemHeight}px`;
        item.style.transform = `translate3d(${
          visible ? positions.get(index) : -9999
        }px, 0, 0)`;
        if (active) item.setAttribute("data-active", "true");
        else item.removeAttribute("data-active");
        if (source) {
          source.style.width = "100%";
          source.style.height = "100%";
          source.style.transform = "none";
          source.dataset.loaded = "true";
          source.dataset.visible = String(visible);
        }
        if (link) link.tabIndex = visible ? 0 : -1;
      });
    };

    const show = (index) => {
      activeIndex = (index + items.length) % items.length;
      positionItems();
    };
    const previous = () => show(activeIndex - 1);
    const next = () => show(activeIndex + 1);
    controls[0]?.addEventListener("click", previous);
    controls[1]?.addEventListener("click", next);
    window.addEventListener("resize", positionItems);
    resizeTasks.push(positionItems);
    cleanup.push(() => {
      controls[0]?.removeEventListener("click", previous);
      controls[1]?.removeEventListener("click", next);
      window.removeEventListener("resize", positionItems);
    });
  });

  return {
    destroy: () => cleanup.forEach((task) => task()),
    resize: () => resizeTasks.forEach((task) => task()),
  };
};

export default function SquarespaceMirror({
  fallback,
  page,
  src,
}) {
  const hostRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [ready, setReady] = useState(false);
  const [quotesMount, setQuotesMount] = useState(null);
  const initialHeight = useMemo(
    () => initialHeightFor(page.path),
    [page.path],
  );

  // Older bootcamp application links target content inside the shadow root,
  // which the browser's ordinary fragment navigation cannot reach.
  useEffect(() => {
    if (!ready || page.path !== "/bootcamp" || location.hash !== "#application") {
      return undefined;
    }
    const frame = window.requestAnimationFrame(() => {
      hostRef.current?.shadowRoot?.getElementById("application")?.scrollIntoView({ behavior: "instant" });
    });
    return () => window.cancelAnimationFrame(frame);
  }, [ready, page.path, location.hash]);

  useEffect(() => {
    if (process.env.NODE_ENV === "test") return undefined;

    const controller = new AbortController();
    const host = hostRef.current;
    const shadow = host.shadowRoot || host.attachShadow({ mode: "open" });
    setReady(false);
    setQuotesMount(null);
    shadow.replaceChildren();

    const renderMirror = async () => {
      const response = await fetch(src, { signal: controller.signal });
      if (!response.ok) {
        throw new Error(`Unable to load ${src}: ${response.status}`);
      }
      const source = new DOMParser().parseFromString(
        await response.text(),
        "text/html",
      );
      if (controller.signal.aborted) return;

      const stylesheetLoads = [];
      for (const node of source.head.querySelectorAll(
        'link[rel="stylesheet"], style',
      )) {
        if (node.tagName === "LINK") {
          const clone = document.createElement("style");
          shadow.appendChild(clone);
          stylesheetLoads.push(
            loadMirrorStylesheet(node.href).then((css) => {
              if (!controller.signal.aborted) clone.textContent = css;
            }),
          );
        } else {
          const clone = document.createElement("style");
          clone.textContent = activateShadowCss(node.textContent);
          shadow.appendChild(clone);
        }
      }

      const html = document.createElement("html");
      copyAttributes(source.documentElement, html);
      const body = document.createElement("body");
      copyAttributes(source.body, body);
      body.innerHTML = source.body.innerHTML;
      configureBackgroundVideos(body);
      hydrateGenerativeBackgrounds(body);
      hydrateForms(body, page.path);
      hydrateSocialIcons(body);
      hydrateSocialFeed(body);
      initializeLegacySpacers(body);
      const legacyImageCards = initializeLegacyImageCards(body);
      body.querySelectorAll("script").forEach((script) => script.remove());
      body.querySelectorAll("style").forEach((style) => {
        const activeStyle = document.createElement("style");
        activeStyle.textContent = activateShadowCss(style.textContent);
        style.replaceWith(activeStyle);
      });
      html.appendChild(body);
      shadow.appendChild(html);
      const runtimeStyle = document.createElement("style");
      runtimeStyle.textContent = mirrorRuntimeCss;
      shadow.appendChild(runtimeStyle);
      if (page.path === "/" || page.path === "/home") {
        const videoSection = body.querySelector("main#page video")?.closest("section");
        if (videoSection) {
          const mount = document.createElement("div");
          mount.className = "participant-quotes-mount";
          videoSection.after(mount);
          setQuotesMount(mount);
        }
      }
      const galleries = initializeClassicGalleries(body);
      const bannerSlideshows = initializeBannerSlideshows(body);
      const itemCarousels = initializeItemCarousels(body);
      const scaledText = initializeScaledText(body);
      const galleryReels = initializeGalleryReels(body);
      const sectionDividers = initializeSectionDividers(body);
      let blogImageLoader;
      let fluidImages;

      const firstPageSection = body.querySelector(
        "main#page section[data-test='page-section']",
      );
      const cartSystemPage =
        page.path === "/cart" ? body.querySelector(".system-page") : null;
      const syncHeaderSpacing = () => {
        const spacingTarget = firstPageSection || cartSystemPage;
        if (!spacingTarget) return;
        spacingTarget.style.paddingTop = getComputedStyle(
          document.documentElement,
        ).getPropertyValue("--header-height");
        if (cartSystemPage) {
          cartSystemPage.style.paddingBottom =
            window.innerWidth < 768 ? "0px" : "";
        }
      };
      syncHeaderSpacing();
      window.addEventListener("resize", syncHeaderSpacing);

      const handleClick = (event) => {
        const anchor = event.target.closest?.("a[href]");
        if (anchor) {
          const url = new URL(anchor.href, window.location.href);
          if (
            url.origin === window.location.origin &&
            !anchor.hasAttribute("download")
          ) {
            event.preventDefault();
            navigate(`${url.pathname}${url.search}${url.hash}`);
            return;
          }
        }

        const accordionButton = event.target.closest?.(
          ".accordion-item__click-target",
        );
        if (!accordionButton) return;
        toggleSquarespaceAccordion(accordionButton);
        window.requestAnimationFrame(sectionDividers.resize);
      };

      const handleSubmit = async (event) => {
        const sessionForm = event.target.closest?.("form#inputForm");
        if (sessionForm) {
          event.preventDefault();
          const userInput =
            sessionForm.querySelector("#userInput")?.value || "";
          window.location.href =
            "https://dashboard.10k.science/public/sessions/" +
            encodeURIComponent(userInput);
          return;
        }

        const form = event.target.closest?.("form[data-formspree-mirror]");
        if (!form) return;
        event.preventDefault();
        const submit = form.querySelector('[type="submit"]');
        const originalLabel = submit?.value || submit?.textContent || "";
        if (submit) {
          submit.disabled = true;
          if ("value" in submit) submit.value = "Sending…";
          else submit.textContent = "Sending…";
        }
        let status = form.querySelector(".mirror-form-status");
        if (!status) {
          status = document.createElement("p");
          status.className = "mirror-form-status";
          status.setAttribute("role", "status");
          form.appendChild(status);
        }
        try {
          const response = await fetch(formspreeEndpoint, {
            method: "POST",
            body: new FormData(form),
            headers: { Accept: "application/json" },
          });
          if (!response.ok) throw new Error("Submission failed");
          status.textContent =
            "Thank you! Your submission has been received.";
          form.reset();
        } catch {
          status.textContent =
            "Something went wrong. Please try again or email info@dynamoid.com.";
        } finally {
          if (submit) {
            submit.disabled = false;
            if ("value" in submit) submit.value = originalLabel;
            else submit.textContent = originalLabel;
          }
        }
      };

      shadow.addEventListener("click", handleClick);
      shadow.addEventListener("submit", handleSubmit);
      controller.signal.addEventListener(
        "abort",
        () => {
          shadow.removeEventListener("click", handleClick);
          shadow.removeEventListener("submit", handleSubmit);
          window.removeEventListener("resize", syncHeaderSpacing);
          galleries.destroy();
          bannerSlideshows.destroy();
          itemCarousels.destroy();
          scaledText.destroy();
          galleryReels.destroy();
          sectionDividers.destroy();
          blogImageLoader?.destroy();
          legacyImageCards.destroy();
          fluidImages?.destroy();
        },
        { once: true },
      );

      await Promise.all(stylesheetLoads);
      if (controller.signal.aborted) return;
      fluidImages = initializeFluidImages(body);
      legacyImageCards.resize();
      galleries.resize();
      bannerSlideshows.resize();
      itemCarousels.resize();
      scaledText.resize();
      galleryReels.resize();
      sectionDividers.resize();
      blogImageLoader = initializeBlogImageLoader(body);
      setReady(true);
    };

    renderMirror().catch((error) => {
      if (error.name !== "AbortError") {
        console.error(error);
      }
    });

    return () => controller.abort();
  }, [navigate, page.path, src]);

  return (
    <div
      className={`squarespace-mirror${
        page.path === "/cart" ? " squarespace-mirror--cart" : ""
      }`}
    >
      <div
        aria-label={`${page.title} page content`}
        className="squarespace-mirror__host"
        ref={hostRef}
        role="document"
        style={ready ? undefined : { minHeight: initialHeight }}
      />
      {quotesMount && createPortal(<ParticipantQuotes />, quotesMount)}
      <div
        aria-hidden="true"
        className="squarespace-mirror__semantic"
        data-testid="mapped-page-semantic-fallback"
      >
        {fallback}
      </div>
    </div>
  );
}
